
import { defineComponent } from "@vue/composition-api";
import BaseBreadCrumbs from "@/components/shared/breadcrumbs/BaseBreadCrumbs.vue";
import BaseHeaderLinks from "@/components/shared/header/BaseHeaderLinks.vue";

export default defineComponent({
  name: "BaseHeaderList",
  components: { BaseBreadCrumbs, BaseHeaderLinks },
});
